export default __webpack_public_path__ + "static/media/etapa2.bd88f494.png";